import React from "react";
import chevron_up from "../../../images/chevron_up.svg";
import { motion } from "framer-motion";
import { cardVariants } from "../../../utils/animations"
import { Link } from "gatsby";

function ServiceCard({ link, service }) {
  return (
    <motion.div
      variants={cardVariants}
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true, amount: 0.3 }}
      className="bg-white aspect-[337/303] p-5 flex flex-col items-center justify-center border w-full flex-none rounded-3xl shadow-[0px_3px_12px_0px_#4A3AFF2E]"
    >
      <div className={`  mb-4`}>
        <img className="w-full" src={service.image} alt="" />
      </div>
      <p className="mb-4  font-[700] h-[50px] text-center text-[20px]">
        {service.title}
      </p>
      <p className="quicksand  px-4 text-center h-[70px]  text-[12px] text-[#5E587A] ">
        {service.description}
      </p>

      <Link to={service.url} className="flex items-center gap-2 cursor-pointer">
        <p className="text-[#2E3192]">View case study</p>
        <img className="rotate-90" src={chevron_up} alt="" />
      </Link>
    </motion.div>
  );
}

export default ServiceCard;
